import { useQuery } from '@tanstack/react-query';

import { SavingsPlan, savingsService } from '@aslanpay/portal-common-lib';

const useFetchSavingsPlan = (savingId: string, enabled = true) => {
  return useQuery<SavingsPlan, Error>(
    ['fetchSavingsPlan', savingId],
    () => savingsService.fetchSavingsPlan(savingId),
    { enabled: enabled && !!savingId }
  );
};

export default useFetchSavingsPlan;
